export const getFileExtension = (src = '') => {
  const fileExtension = src.split('?').reverse().pop()?.split('.').pop()

  // If there's "/" in the string, then the `split(.)` picks up the "." from a
  // domain, and we get and output like so: `com/path`.
  return fileExtension?.includes('/') ? false : fileExtension
}
